(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artro-v3-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHero = (root) => {
      if (!root || root.dataset.artroV3HeroInit === 'true') return;

      const modal = root.querySelector('[data-artro-v3-study-modal]');
      const openButtons = root.querySelectorAll('[data-artro-v3-study-open]');
      const closeButtons = root.querySelectorAll('[data-artro-v3-study-close]');

      if (!modal || openButtons.length === 0) return;

      root.dataset.artroV3HeroInit = 'true';
      let previousFocus = null;

      const openModal = () => {
        previousFocus = document.activeElement;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('artro-v3-study-modal-open');
        window.setTimeout(() => {
          const closeButton = modal.querySelector('[data-artro-v3-study-close]');
          if (closeButton) closeButton.focus();
        }, 100);
      };

      const closeModal = () => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('artro-v3-study-modal-open');
        if (previousFocus && typeof previousFocus.focus === 'function') {
          previousFocus.focus();
        }
      };

      openButtons.forEach((button) => {
        button.addEventListener('click', openModal);
      });

      closeButtons.forEach((button) => {
        button.addEventListener('click', closeModal);
      });

      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeModal();
      });

      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal();
        }
      });
    };

    const initAll = (scope = document) => {
      if (scope.matches && scope.matches('[data-artro-v3-hero-root]')) {
        initHero(scope);
      }
      if (scope.querySelectorAll) {
        scope.querySelectorAll('[data-artro-v3-hero-root]').forEach(initHero);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(document));
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-terms"]) return;
  try {
    
(() => {
  const sections = document.querySelectorAll('[data-legal-terms]');
  sections.forEach((section) => {
    if (section.dataset.termsBound === 'true') return;
    section.dataset.termsBound = 'true';

    const source = section.querySelector('[data-terms-json]');
    if (!source) return;

    let payload;
    try {
      payload = JSON.parse(source.textContent.trim());
    } catch (error) {
      console.error('[Legal terms] JSON parse error', error);
      return;
    }

    const content = payload && payload.data ? payload.data.terms_and_condition_section : null;
    if (!content) return;

    const heading = section.querySelector('[data-terms-heading]');
    const subheading = section.querySelector('[data-terms-subheading]');
    const list = section.querySelector('[data-terms-list]');
    const contact = section.querySelector('[data-terms-contact]');
    const template = section.querySelector('[data-terms-item-template]');

    if (heading) heading.textContent = content.heading || '';
    if (subheading) subheading.textContent = content.sub_heading || '';

    if (contact && content.contact_information) {
      contact.innerHTML = content.contact_information;
    }

    if (!list || !template || !content.terms_and_conditions || !Array.isArray(content.terms_and_conditions.item_list)) return;

    content.terms_and_conditions.item_list.forEach((item) => {
      const node = template.content.cloneNode(true);
      const wrapper = node.querySelector('[data-terms-item]');
      const title = node.querySelector('[data-terms-title]');
      const body = node.querySelector('[data-terms-body]');
      const icon = node.querySelector('[data-terms-icon]');
      const contentWrap = node.querySelector('[data-terms-content]');

      if (title) title.textContent = item.title || '';
      if (body) body.textContent = item.content || '';

      if (wrapper && contentWrap) {
        wrapper.addEventListener('click', () => {
          const isOpen = wrapper.dataset.open === 'true';

          list.querySelectorAll('[data-terms-item]').forEach((other) => {
            if (other === wrapper) return;
            other.dataset.open = 'false';
            const otherIcon = other.querySelector('[data-terms-icon]');
            const otherContent = other.querySelector('[data-terms-content]');
            if (otherIcon) otherIcon.classList.remove('rotate-180');
            if (otherContent) {
              otherContent.classList.remove('grid-rows-[1fr]');
              otherContent.classList.add('grid-rows-[0fr]');
            }
          });

          if (isOpen) {
            wrapper.dataset.open = 'false';
            if (icon) icon.classList.remove('rotate-180');
            contentWrap.classList.remove('grid-rows-[1fr]');
            contentWrap.classList.add('grid-rows-[0fr]');
          } else {
            wrapper.dataset.open = 'true';
            if (icon) icon.classList.add('rotate-180');
            contentWrap.classList.remove('grid-rows-[0fr]');
            contentWrap.classList.add('grid-rows-[1fr]');
          }
        });
      }

      list.appendChild(node);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
